import { useMutation } from '@tanstack/react-query'
import type { UserLoginByPasswordInput } from '../..'
import { userLoginByPassword } from './login-by-password.service'

export const useLoginByPassword = () => {
  return useMutation({
    mutationFn: (data: UserLoginByPasswordInput) => userLoginByPassword(data),
  })
}
